import React from "react";
import "../../css/ac/wawe.css";

function WaveAnimation() {
    return (
        <div className="wawe-page-container">
        <div className="wawe-page-second-container">

            {/* Üst Yazılar */}
            <div className="text-section" style={{ marginBottom: "30px" }}>
                <h1>Esnek Şarj, Sadece Sizin İçin</h1>
                <p className="WavesText">
                    DapŞarj uygulaması, Smart, Premium ve Dual Şarj Cihazına kolay erişim sağlar. Uygulama, RFID kart ve Bluetooth olmak üzere üç farklı kimlik doğrulama seçeneği sunar.
                </p>
                <p className="WavesText">
                    Ayrıca şarj erişim izninizi DapŞarj uygulaması üzerinden dilediğiniz kişilerle (komşularınız, arkadaşlarınız vb.) paylaşabilirsiniz."
                </p>
            </div>

            {/* Ana İçerik */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                        width: "90%",
                
                }}
            >
                {/* Bluetooth Icon */}
                <div className="icon-container">
                    <div className="container">
                        <div className="icon">
                            <img
                                src="/assets/home/bluetooth.png"
                                alt="Bluetooth"
                            />
                        </div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                    </div>
                    <img
                        className="basic-image" src="/assets/home/stations/basic.png"
                        alt="Basic"
                    />
                </div>

                {/* RFID Icon */}
                <div className="icon-container">
                    <div className="container">
                        <div className="icon">
                            <img src="/assets/home/rfid.png" alt="RFID" style={{ width: "50px" }} />
                        </div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                    </div>
                    <img
                        className="cihaz-image"
                        src="/assets/home/stations/cihaz.png"
                        alt="Cihaz"
                    />
                </div>

                {/* Phone Icon */}
                <div className="icon-container">
                    <div className="container">
                        <div className="icon">
                            <img
                                src="/assets/home/application.png"
                                alt="App"
                                className="iconsWhite"
                            />
                        </div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                    </div>
                    <img
                        className="smart-image"
                        width="150"
                        src="/assets/home/stations/smart.png"
                        alt="Smart"
                    />
                </div>
            </div>
        </div>
        </div>

    );
}

export default WaveAnimation;
